import React from 'react'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll'

const parse = mdLink => {
  const pattern = new RegExp(
    /\[([^\]]*?)\]\(((http|www\.|\#|\.com|\.net|\.info|\.org).*)\)/,
    'g'
  )
  const result = pattern.exec(mdLink)
  return { label: result ? result[1] : mdLink, url: result && result[2] }
}

const Nav = ({ sticky, items, menuTitle }) => (
  <nav id="nav" className={sticky ? 'alt' : ''}>
    <span>{menuTitle}</span>
    <Scrollspy items={items} currentClassName="is-active" offset={-300}>
      {items.map(item => {
        const { label, url } = parse(item)
        if (url) {
          return (
            <li key={label}>
              <a href={url || '#'}>{label}</a>
            </li>
          )
        } else {
          return (
            <li key={label}>
              <Scroll type="id" element={label}>
                <a href="#">{label}</a>
              </Scroll>
            </li>
          )
        }
      })}
    </Scrollspy>
  </nav>
)

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav.js